import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (aiInventoryId) =>
  dponetAPI.get(`/ai_inventories/${aiInventoryId}/ai_inventory_purposes`)

const create = async (aiInventoryId, data) =>
  dponetAPI.post(`/ai_inventories/${aiInventoryId}/ai_inventory_purposes`, {
    aiInventoryPurpose: data,
  })

const destroy = async (aiInventoryId, purposeId) =>
  dponetAPI.delete(
    `/ai_inventories/${aiInventoryId}/ai_inventory_purposes/${purposeId}`,
  )

export default { get, create, destroy }
